"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  NONE: null,
  IMAGE_SLIDER: null,
  FORM: null,
  SOCIAL_SHARING: null,
  POST_LISTING: null,
  FOLLOW_ME: null,
  POST_FILTER: null,
  CTA: null,
  HERO_IMAGE: null,
  NAV_MENU: null,
  SUB_MENU: null,
  BACKGROUND_IMAGE: null,
  BACKGROUND_VIDEO: null,
  BLOG_EMAIL_SUBSCRIPTION: null,
  MAP: null,
  PRICING_TABLE: null
});

exports.default = _default;
module.exports = exports.default;